import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type {
  QcTest,
  QcTestMetricLine,
} from "@/app/services/generated/qctestService";
import { qcTestService } from "@/app/services/generated/qctestService";
import { GuidMap } from "@/app/types/common/guidcollections";
import { toGuidMap } from "@/app/apiutils";
import type { Maybe } from "@/components/utils/typeHelpers";
import type Guid from "@/app/types/common/guid";

export interface IHasQcTestsCache {
  qcTests: QcTestsCache;
}

// Singleton cache store
const qcTestsCacheStore = new EntityCacheStore<QcTest>(
  EnumCacheEntityType.qcTest,
  async () => qcTestService.getAllQcTests()
);

// Ephemeral reader
export default class QcTestsCache extends EntityWithGuidKeyCache<QcTest> {
  _metrics: GuidMap<QcTestMetricLine> = new GuidMap<QcTestMetricLine>();

  constructor() {
    super(qcTestsCacheStore, (x) => x.header.id);
  }

  async update(): Promise<void> {
    await super.update();
    this._metrics = toGuidMap(
      this.all.flatMap((x) => x.metricLines),
      (x) => x.id
    );
  }

  getMetricById(id: Maybe<Guid>) {
    return this._metrics.get(id) ?? null;
  }
}
